import axios from "axios";
import { getAuth, getIdToken } from "firebase/auth";
import { enqueueSnackbar } from "notistack";
const { REACT_APP_URL } = process.env;
if (!REACT_APP_URL) {
  console.warn("REACT_APP_URL is not set. Sending API requests to this page's origin.");
}

export const getUserToken = async () => {
  const user = getAuth().currentUser;
  if (!user) {
    return null;
  }
  try {
    const token = await getIdToken(user);
    return token;
  } catch (e) {
    console.error("Failed to get ID token", e);
    return null;
  }
};

export const axiosInstance = axios.create({
  // Request paths already start with /api.
  baseURL: REACT_APP_URL || "",
  timeout: 15000,
});

axiosInstance.interceptors.request.use(async (request) => {
  const token = await getUserToken();
  if (token) {
    request.headers = {
      ...(request.headers || {}),
      Authorization: `Bearer ${token}`,
    };
  }
  return request;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      console.warn("Unauthorized (401).", error);
    } else if (status === 429 && !error?.response?.data?.code) {
      // A 429 with a code (e.g. DAILY_LIMIT) carries its own message, shown by the caller.
      enqueueSnackbar("Zbyt wiele żądań. Poczekaj chwilę i spróbuj ponownie.", { variant: "warning" });
    } else if (status && status >= 500) {
      console.error("Server error:", error);
    }
    return Promise.reject(error);
  }
);
